// Original educational scenarios; checked 2026-11-05.
export const taiwanTaxLessons = [
  {
    "id": "tw-tax-map",
    "moduleId": "taiwan-tax",
    "title": "投資入帳的錢，都用同一種方式課稅嗎？",
    "subtitle": "先分所得、來源與適用身分",
    "minutes": 6,
    "tag": "台灣投資稅務",
    "objectives": [
      "分開辨認本金、所得與費用",
      "在套用稅率前確認年度、居住身分及來源"
    ],
    "paragraphs": [
      "先辨認一筆入帳是取回本金、股利、利息或出售資產的收款，再依交易與所得資料判斷所得。出售收到的總價款，不等於整筆都是獲利；也不能只從銀行入帳金額反推法定所得。各類成本與損失可否扣除，須按所得類別查核。",
      "台灣投資稅務須先確認所得年度、居住身分、所得來源和申報單位。國籍、交易平台設在哪裡或使用哪種幣別，單獨一項都不足以判定所有課稅結果；本單元限定境內居住者的一般教學情境。",
      "基金配息可能含不同所得項目，應讀取分配通知與憑單，不把配息總額直接當作同一種國內股利。所得稅、證券交易相關稅費與健保補充保費也各有規則；本課不以一個總百分比概括它們。"
    ],
    "example": {
      "title": "假設案例，逐步核對",
      "steps": [
        "假設賣出一筆資產收到 120,000 元，原取得成本 100,000 元，另付成交費用 500 元。",
        "經濟上未計所得稅的損益為 120,000−100,000−500＝19,500 元。",
        "這個現金損益不是稅法認定的應稅所得結論；應再確認資產、來源與成本認列規則。"
      ],
      "conclusion": "先把交易事實整理清楚，再依適用制度分類。"
    },
    "pitfalls": [
      "把入帳總額全算成獲利。",
      "只看台幣或外幣就決定所得來源。"
    ],
    "glossary": [
      {
        "term": "所得年度",
        "definition": "所得歸屬的年度，與之後辦理申報的年度可能不同。"
      },
      {
        "term": "所得分類",
        "definition": "依所得性質和適用法規辨認應如何計算與申報。"
      }
    ],
    "takeaway": "先把交易事實整理清楚，再依適用制度分類。",
    "exercise": "用一份虛構對帳單，分別標示本金、股利、費用和待查項目；不需要輸入真實帳號。",
    "quiz": {
      "question": "一筆出售入帳包含本金與損益，整理稅務資料時應先怎麼做？",
      "options": [
        "把整筆入帳視為股利",
        "列出交易、成本與費用，再確認所得分類及認列規則",
        "只要銀行沒有扣稅，就不必確認"
      ],
      "answer": 1,
      "explanation": "先辨認交易和適用規則；現金入帳與法定所得不是同一個概念。"
    },
    "sources": [
      {
        "label": "財政部｜所得分類與股利課稅",
        "url": "https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-saving-manual/national/individual-income-tax/gLA3Vax",
        "kind": "official"
      },
      {
        "label": "南區國稅局｜海外所得、損失抵減與對帳單",
        "url": "https://www.ntbsa.gov.tw/singlehtml/5e0e49a811b74b50b5a6486d38374285?cntId=1c5ab0b09cc2436ea3ebc6cf45bb2729",
        "kind": "official"
      }
    ],
    "verifiedAt": "2026-11-05",
    "scopeNote": "以114（2025）所得年度、台灣境內居住者的一般情境教學；申報年度為115（2026）年。非居住者、特殊所得及其他年度須另查規定；不是個別申報試算。",
    "incomeYear": 2025
  },
  {
    "id": "tw-dividend-tax",
    "moduleId": "taiwan-tax",
    "title": "股利的 8.5% 和 28%，是在比什麼？",
    "subtitle": "先懂制度，再比較全戶稅負",
    "minutes": 6,
    "tag": "台灣投資稅務",
    "objectives": [
      "區分股利可抵減稅額與最終稅負",
      "知道二擇一須比較全戶完整計算"
    ],
    "paragraphs": [
      "依本課採用的114所得年度境內居住者一般制度，符合規定的股利可選併入綜合所得，以全戶股利及盈餘的8.5%計算可抵減稅額，每戶上限80,000元；也可就全戶適用股利按28%單一稅率分開計稅，再合併報繳。",
      "8.5%是特定計算下的可抵減稅額，不是所有股利都固定課8.5%，也不是投資報酬率。28%則是另一選項中適用股利的計稅率。比較時要納入其他所得、扣除與全戶條件，不能只拿兩個百分比比大小。",
      "以下只練習兩項中間數字，不判定哪個選項適合某人。健保補充保費及其他費稅不由這段計算包辦；配息來源不同、非居住者或其他年度也不能直接套用。"
    ],
    "example": {
      "title": "假設案例，逐步核對",
      "steps": [
        "假設全戶適用股利為 200,000 元：合併選項的股利可抵減稅額為 200,000×8.5%＝17,000 元，尚未達上限。",
        "分開選項中，該股利的稅額為 200,000×28%＝56,000 元，其他所得稅額仍須另計。",
        "17,000 元抵減和 56,000 元股利稅額不是兩個完整全戶稅額；尚不能僅憑這兩數下選擇。"
      ],
      "conclusion": "比較的是完整申報結果，不是兩個百分比的大小。"
    },
    "pitfalls": [
      "把抵減率誤當固定所得稅率。",
      "把中間抵減額直接當成必定退稅的金額。"
    ],
    "glossary": [
      {
        "term": "股利可抵減稅額",
        "definition": "合併計稅選項中依適用年度規定計算的抵減項目，並非完整稅負。"
      },
      {
        "term": "股利分開計稅",
        "definition": "將適用股利按規定單一稅率計算，再與其他所得稅額合併報繳的選項。"
      }
    ],
    "takeaway": "比較的是完整申報結果，不是兩個百分比的大小。",
    "exercise": "列出比較兩種選項需要的三類資料：所得、扣除及申報戶條件；只做資料準備。",
    "quiz": {
      "question": "114所得年度，全戶適用股利為1,200,000元，按8.5%計算並受80,000元上限限制，可抵減稅額是多少？",
      "options": [
        "102,000元",
        "80,000元",
        "336,000元"
      ],
      "answer": 1,
      "explanation": "1,200,000×8.5%＝102,000元，受每戶80,000元上限限制；336,000元是28%選項的股利稅額中間數。"
    },
    "sources": [
      {
        "label": "財政部｜所得分類與股利課稅",
        "url": "https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-saving-manual/national/individual-income-tax/gLA3Vax",
        "kind": "official"
      }
    ],
    "verifiedAt": "2026-11-05",
    "scopeNote": "以114（2025）所得年度、台灣境內居住者的一般情境教學；申報年度為115（2026）年。非居住者、特殊所得及其他年度須另查規定；不是個別申報試算。",
    "incomeYear": 2025
  },
  {
    "id": "tw-overseas-income",
    "moduleId": "taiwan-tax",
    "title": "海外所得達 100 萬，就一定要多繳稅嗎？",
    "subtitle": "計入門檻與基本所得額免稅額分開看",
    "minutes": 6,
    "tag": "台灣投資稅務",
    "objectives": [
      "分辨海外所得計入門檻與基本稅額計算",
      "知道不能將免稅額誤當海外所得申報門檻"
    ],
    "paragraphs": [
      "依本課採用年度的規定，同一申報戶全年海外所得合計達100萬元，應全數計入基本所得額；未達100萬元，海外所得無須計入這項基本所得額計算。這不是只把超過100萬元的部分放入。",
      "計入後還須和其他依法應計入項目一起計算。114年度基本所得額免稅額為750萬元；它針對整個基本所得額，不是「海外所得750萬元以下都不用申報」。是否產生額外基本稅額，仍須完成法定計算與一般所得稅額等比較。",
      "本制度的海外所得定義包含非中華民國來源及香港、澳門來源所得，大陸地區來源所得另依規定處理。海外財產交易損失的扣除有類別、年度與證明限制，不能任意跨類抵掉利息或股利。"
    ],
    "example": {
      "title": "假設案例，逐步核對",
      "steps": [
        "假設全戶全年海外所得1,200,000元，已達100萬元計入門檻，計入的是1,200,000元，不是200,000元。",
        "再假設其他所有應計入項目合計2,000,000元，基本所得額合計3,200,000元。",
        "本例低於114年度750萬元免稅額，因此不因這個基本所得額產生基本稅額；仍應正確處理原本一般所得申報。"
      ],
      "conclusion": "達計入門檻不等於必定多繳稅；是否要計入和最後稅額是兩個問題。"
    },
    "pitfalls": [
      "只計入超過100萬元的部分。",
      "把750萬元當作海外所得可以不查不報的界線。"
    ],
    "glossary": [
      {
        "term": "基本所得額",
        "definition": "依所得基本稅額條例將指定項目加計後的計算基礎。"
      },
      {
        "term": "海外所得計入門檻",
        "definition": "用來判斷全戶全年海外所得是否須全數計入基本所得額的門檻。"
      }
    ],
    "takeaway": "達計入門檻不等於必定多繳稅；是否要計入和最後稅額是兩個問題。",
    "exercise": "畫出「全戶海外所得→是否計入→全部基本所得額→稅額比較」四步驟，並標記每個數字的年度。",
    "quiz": {
      "question": "114所得年度全戶海外所得110萬元，達門檻後應計入多少海外所得？",
      "options": [
        "10萬元",
        "0元，因為低於750萬元",
        "110萬元，是否增加稅額再另計"
      ],
      "answer": 2,
      "explanation": "達100萬元後全數計入；750萬元是整個基本所得額的免稅額，不是這一步的計入門檻。"
    },
    "sources": [
      {
        "label": "財政部｜海外所得計入基本所得額門檻",
        "url": "https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/basic-tax-question/oversea-income/DErVYaG",
        "kind": "official"
      },
      {
        "label": "財政部｜海外所得達門檻不等於必須繳基本稅額",
        "url": "https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/basic-tax-question/oversea-income/awYgOG9",
        "kind": "official"
      },
      {
        "label": "南區國稅局｜海外所得、損失抵減與對帳單",
        "url": "https://www.ntbsa.gov.tw/singlehtml/5e0e49a811b74b50b5a6486d38374285?cntId=1c5ab0b09cc2436ea3ebc6cf45bb2729",
        "kind": "official"
      }
    ],
    "verifiedAt": "2026-11-05",
    "scopeNote": "以114（2025）所得年度、台灣境內居住者的一般情境教學；申報年度為115（2026）年。非居住者、特殊所得及其他年度須另查規定；不是個別申報試算。",
    "incomeYear": 2025
  },
  {
    "id": "tw-tax-records",
    "moduleId": "taiwan-tax",
    "title": "已經扣過錢，為什麼還要看全年申報？",
    "subtitle": "本金、費用、預扣與最後稅額",
    "minutes": 6,
    "tag": "台灣投資稅務",
    "objectives": [
      "讀出總額、扣款與淨入帳",
      "分開整理扣繳憑證及跨境所得文件"
    ],
    "paragraphs": [
      "投資機構通知中的費用、稅款預扣與淨入帳，描述的是不同項目。某筆收入已扣款，不代表所有台灣全年申報義務都已結清；預扣或已納稅額如何扣抵，須依來源地、稅種、年度與證明文件判斷。",
      "可按年度整理交易明細、成本、分配通知、已納稅證明及換匯資料。海外所得通常不在國稅局提供查詢的所得清單範圍內，不能因下載清單沒有出現就認為不存在。",
      "下面只練習對帳，不示範某國稅率或保證外國稅可全額抵扣。個別申報應使用該年度官方說明；資料有差異時先釐清，不把銀行餘額當作唯一依據。"
    ],
    "example": {
      "title": "假設案例，逐步核對",
      "steps": [
        "假想通知寫所得總額10,000元、來源地預扣1,000元、服務費100元，淨入帳8,900元。",
        "10,000−1,000−100＝8,900元，現金對得上；仍應分別保留總所得、預扣及費用紀錄。",
        "台灣申報時各項應如何認列與扣抵，不能僅由8,900元反推，亦不能把1,000元直接當成已完成所有稅負。"
      ],
      "conclusion": "對帳能確認現金，申報還要確認制度與證明。"
    },
    "pitfalls": [
      "用淨入帳取代所有所得文件。",
      "認定來源地已扣稅，台灣就一定不用申報。"
    ],
    "glossary": [
      {
        "term": "淨入帳",
        "definition": "總收款扣除當次費用、預扣等項目後，實際進入帳戶的金額。"
      },
      {
        "term": "已納稅證明",
        "definition": "用來證明已支付某項稅款的文件，能否扣抵仍受適用規則限制。"
      }
    ],
    "takeaway": "對帳能確認現金，申報還要確認制度與證明。",
    "exercise": "做一份空白年度資料清單，只放文件種類與取得狀態，不放帳號或身分證字號。",
    "quiz": {
      "question": "總額8,000元，預扣800元，服務費50元，淨入帳是多少？這能否證明全年稅負結清？",
      "options": [
        "7,150元，不能單憑淨入帳證明",
        "7,200元，可以證明",
        "8,000元，扣款不影響現金"
      ],
      "answer": 0,
      "explanation": "8,000−800−50＝7,150元；這只是當次收付款核對。"
    },
    "sources": [
      {
        "label": "財政部｜扣繳與免扣繳規定",
        "url": "https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule",
        "kind": "official"
      },
      {
        "label": "南區國稅局｜海外所得、損失抵減與對帳單",
        "url": "https://www.ntbsa.gov.tw/singlehtml/5e0e49a811b74b50b5a6486d38374285?cntId=1c5ab0b09cc2436ea3ebc6cf45bb2729",
        "kind": "official"
      }
    ],
    "verifiedAt": "2026-11-05",
    "scopeNote": "以114（2025）所得年度、台灣境內居住者的一般情境教學；申報年度為115（2026）年。非居住者、特殊所得及其他年度須另查規定；不是個別申報試算。",
    "incomeYear": 2025
  }
];
